export default function ServicesExpediteSection() {
  const services = [
    { icon: "ri-passport-line", title: "Passport Renewal (DS-82)", desc: "No office visit for eligible renewals.", href: "/passport-services/renewal/" },
    { icon: "ri-file-add-line", title: "New Passport (DS-11)", desc: "First-time applicants.", href: "/passport-services/new-passport/" },
    { icon: "ri-alert-line", title: "Lost or Stolen Passport", desc: "Urgent replacement.", href: "/passport-services/lost-stolen/" },
    { icon: "ri-parent-line", title: "Child Passport", desc: "Both parents required — we handle after DS-11 step.", href: "/passport-services/child-passport/" },
    { icon: "ri-file-copy-2-line", title: "Second Passport", desc: "For frequent travelers.", href: "/passport-services/second-passport/" },
    { icon: "ri-error-warning-line", title: "Damaged Passport", desc: "Replacement processing.", href: "/passport-services/damaged-passport/" },
    { icon: "ri-user-heart-line", title: "Name Change Passport", desc: "DS-82 with name change docs.", href: "/passport-services/name-change/" },
    { icon: "ri-alarm-warning-line", title: "Emergency Passport", desc: "As fast as 24 hours.", href: "/passport-services/emergency-passport/" },
  ];

  return (
    <section id="services" className="py-16 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4 text-center">
          What Our Passport Expediting Service Covers
        </h2>
        <p className="text-gray-600 text-center max-w-2xl mx-auto mb-12 text-base md:text-lg">
          Every type of passport application — handled by registered couriers with daily agency access.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((svc, i) => (
            <a
              key={i}
              href={svc.href}
              className="group bg-[#F7F8FA] rounded-lg p-6 border border-[#D0D7E2] hover:border-[#4A7AB5] hover:bg-[#E8F0FE] transition-all cursor-pointer"
            >
              <div className="w-10 h-10 rounded-full bg-[#1A365D] flex items-center justify-center mb-4 group-hover:bg-[#4A7AB5] transition-colors">
                <i className={`${svc.icon} text-[#C0C8D6] text-lg`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2 group-hover:text-[#1A365D]">{svc.title}</h3>
              <p className="text-gray-500 text-xs leading-relaxed">{svc.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}